module.exports = __webpack_public_path__ + "img/bg1.79b85f89.png";